// extracted by mini-css-extract-plugin
module.exports = {"audioPlayer":"yxdc6","audioLoader":"vxe6D","audioPlayerInner":"z7iYg","headphoneIcon":"yPiHJ","audioPlayerContainer":"CFcOI","audioSummaryDisclaimer":"rM54U"};